import { render, staticRenderFns } from "./x-ellipsis.vue?vue&type=template&id=5bdae323"
import script from "./x-ellipsis.vue?vue&type=script&lang=js"
export * from "./x-ellipsis.vue?vue&type=script&lang=js"
import style0 from "./x-ellipsis.vue?vue&type=style&index=0&id=5bdae323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports